export const POSTHOG_URL = 'https://us.i.posthog.com';

export enum ROUTES {
    // Páginas principales
    HOME_PAGE = "/",
    TASK = "/task",
    TASK_MANAGEMENT = "/tasks-management",
    TASK_CALENDAR = "/task-calendar",
    AUTOMATED_OFFERS = "/automated-offers",
  
    // Métricas
    METRICS = "/metrics",
    METRICS_CATEGORIES = "/metrics/categories",
    METRICS_ASKER = "/metrics/asker",
    METRICS_COMMUNES = "/metrics/communes",
    METRICS_TASKERS = "/metrics/taskers",
    METRICS_GENDER = "/metrics/gender",
    METRICS_COMPLETION = "/metrics/completion",
    METRICS_CATEGORY_TIMEBLOCK = "/metrics/category-timeblock",
    METRICS_SALES_PER_DAY = "/metrics/sales-per-day",
    METRICS_SALES_PER_HELPER = "/metrics/sales-per-helper",
    METRICS_TASKS_PER_COMMUNE_PER_CATEGORY = "/metrics/tasks-per-commune-per-category",
    METRICS_TASKS_PER_COMMUNE_PER_SEX = "/metrics/tasks-per-commune-per-sex",
  
    // Administración
    ADMIN_TASKERS = "/admin/taskers",
    ADMIN_PENDING_TASKERS = "/admin/pending-taskers",
  
    // Taskers
    TASKER_PROFILE = "/tasker/:id",
    TASKERS = "/taskers",
  
    // Pagos
    MP_PAYMENTS = "/mp-payments",
    PAYMENTS = "/payments",
  
    // Tareas y Postulaciones
    RECURRING_TASKS = "/recurring-tasks",
    TASK_POSTULATIONS = "/tasks/:taskId/postulations",
  
    // Otras páginas
    POPUP = "/popup",
    APP_BANNERS = "/app-banners",
    DISCOUNT_COUPONS = "/discount-coupons",
    CATEGORY_TOPICS = "/category-topics",

    TEAM = "/team"
  }